import { Row, Col } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import AdnAutoComplete from "../common/adnAutoComplete/AdnAutoComplete";
import AdnAddButton from "../common/adnAddButton/AdnAddButton";
import AdnCard from "../common/adnCard/AdnCard";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnTable from "../common/adnTable/AdnTable";
import "./WhatsappGroupListForm.css";

export const WhatsappGroupListForm = ({
  title,
  handleSearch,
  handleSelect,
  handleAdd,
  handleTableChanges,
  whatsappGroups,
  searchOptions,
  columns,
  loading,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <AdnPageTitle title={title} />
      <AdnCard loading={loading}>
        <Row>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <AdnAutoComplete
              placeholder={t("whatsappGroup.form.placeholders.searchName")}
              resultList={searchOptions}
              valueId={"name"}
              handleSearch={handleSearch}
              handleSelect={handleSelect}
            />
          </Col>
          <Col
            className="whatsappGroupAddButton"
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 12 }}
            xl={{ span: 18 }}
            xxl={{ span: 18 }}
          >
            <AdnAddButton
              style={{ float: "right" }}
              handleClick={handleAdd}
              name={t("whatsappGroup.form.buttons.whatsappGroup")}
            />
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <AdnTable
              columns={columns}
              data={whatsappGroups}
              handleChange={handleTableChanges}
              totalRecords={whatsappGroups.totalRecords}
            />
          </Col>
        </Row>
      </AdnCard>
    </>
  );
};
